<template>
    <div class="table-responsive">
    <table class="table table-hover no-overflow">
        <thead>
            <tr>
                <th @click="sortBy('referenceNumber')">
                    Folio de Beneficiarios
                    <span v-if="sortKey === 'referenceNumber'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else="sortKey !== 'referenceNumber'">
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('loanApplication.referenceNumber')">
                    Folio de Solicitudes
                    <span v-if="sortKey === 'loanApplication.referenceNumber'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else="sortKey !== 'loanApplication.referenceNumber'">
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <!-- <th @click="sortBy('prospectus.referenceNumber')">
                    Folio de Prospectos
                    <span v-if="sortKey === 'prospectus.referenceNumber'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else="sortKey !== 'prospectus.referenceNumber'">
                        <i class="fas fa-sort"></i>
                    </span>
                </th> -->
                <th @click="sortBy('generalInformation.firstName')">
                    Nombres
                    <span v-if="sortKey === 'generalInformation.firstName'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else="sortKey !== 'generalInformation.firstName'">
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('generalInformation.email')">
                    Correo
                    <span v-if="sortKey === 'generalInformation.email'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else="sortKey !== 'generalInformation.email'">
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('generalInformation.homePhone')">
                    Teléfono
                    <span v-if="sortKey === 'generalInformation.homePhone'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else="sortKey !== 'generalInformation.homePhone'">
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('status.name')" class="id-header-tb">
                    Estatus
                    <span v-if="sortKey === 'status.name'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else="sortKey !== 'status.name'">
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('createdAt')">
                    Fecha de creación
                    <span v-if="sortKey === 'createdAt'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else="sortKey !== 'createdAt'">
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('updatedAt')">
                    Fecha de actualización
                    <span v-if="sortKey === 'updatedAt'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else="sortKey !== 'updatedAt'">
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th>Acciones</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in sortedData" :key="item.id" v-if="sortedData.length != 0">
                <td class="sorting_1 dtr-control"> {{ item.referenceNumber }}</td>
                <td>{{ item.loanApplication.referenceNumber}}</td>
                <!-- <td>{{ item.prospectus.referenceNumber}}</td> -->
                <td>{{ getFullName(item) }}</td>
                <td>{{ item.generalInformation.email }}</td>
                <td>{{ getPhone(item) }}</td>
                <td>{{ item.status.name }}</td>
                <td>{{ dateFormatting(item.createdAt) }}</td>
                <td>{{ dateFormatting(item.updatedAt) }}</td>
                <td>
                    <!-- <PrimaryButton class="btn-success" data-toggle="modal" :data-target="modalDataTarget"
                        @click.prevent="editItem(item)"><i class="fa fa-edit"></i>
                    </PrimaryButton> -->
                    <PrimaryButton class="btn-success" 
                        @click.prevent="editItem(item)"><i class="fa fa-edit"></i>
                    </PrimaryButton>
                </td>
            </tr>
            <tr v-else>
                <td colspan="10" style="text-align: center;">{{ notDataFoundMessage }}</td>
            </tr>
        </tbody>
    </table>
    </div>
</template>

<script>
import PrimaryButton from '@/Components/PrimaryButton.vue';

export default {
    components: { PrimaryButton },
    data() {
        return {
            sortKey: '',
            sortOrder: 1, // 1 for ascending, -1 for descending
        }
    },
    emits: ['click-on-edit-btn'],
    props: {
        list: {
            type: Array,
            default: () => { },
            required: true
        },
        itemsPerPage: {
            type: Number,
            default: () => 10,
        },
        currentPage: {
            type: Number,
            default: () => 1
        },
        modalDataTarget: {
            type: String,
            default: () => '#modal-lg'
        }
    },
    computed: {
        sortedData() {
            let sortedList = [...this.list];
            if (this.sortKey) {
                sortedList.sort((a, b) => {
                    let aValue = this.getNestedValue(a, this.sortKey);
                    let bValue = this.getNestedValue(b, this.sortKey);

                    if (aValue < bValue) return -1 * this.sortOrder;
                    if (aValue > bValue) return 1 * this.sortOrder;
                    return 0;
                });
            }
            return this.paginate(sortedList);
        },
        notDataFoundMessage() {
            return this.$getLocaleMessage('common', 'noDataFound');
        },
    },
    methods: {
        sortBy(key) {
            if (this.sortKey === key) {
                this.sortOrder *= -1; // Toggle the sort order
            } else {
                this.sortOrder = 1; // Reset to ascending if a new column is sorted
            }
            this.sortKey = key;
        },
        getNestedValue(obj, key) {
            return key.split('.').reduce((o, i) => o[i], obj);
        },
        paginate(list) {
            if (!list || list.length === 0) return [];
            let start = (this.currentPage * this.itemsPerPage) - this.itemsPerPage;
            return list.slice(start, start + this.itemsPerPage);
        },
        dateFormatting(date) {
            if (date === '0001-01-01T00:00:00') return null;
            return this.$filters.formatDate(date);
        },
        getFullName(item) {
            if (item.generalInformation.businessName) {
                return `${item.generalInformation.businessName}`;
            } else if (item.generalInformation.firstName && item.generalInformation.lastName) {
                return `${item.generalInformation.firstName} ${item.generalInformation.lastName} ${item.generalInformation.mothersMaidenName}`;
            } else {
                return '';
            }
        },
        getPhone(item) {
            if (item.generalInformation.officePhone) {
                return `${item.generalInformation.officePhone}`;
            } else if (item.generalInformation.homePhone) {
                return `${item.generalInformation.homePhone}`;
            } else {
                return '';
            }
        },
        editItem(item) {
            this.$emit('click-on-edit-btn', item);
        },
    },
}
</script>